import { render, staticRenderFns } from "./radio-button.vue?vue&type=template&id=c18ca7cc&scoped=true"
import script from "./radio-button.vue?vue&type=script&lang=ts"
export * from "./radio-button.vue?vue&type=script&lang=ts"
import style0 from "./radio-button.vue?vue&type=style&index=0&id=c18ca7cc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18ca7cc",
  null
  
)

export default component.exports